const MONO = "'JetBrains Mono', monospace"

type Props = {
    count: number
    className?: string
}

export default function NotificationBadge({ count, className = "" }: Props) {
    if (count <= 0) return null

    return (
        <span
            className={`absolute flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#e4206b] px-1 text-[10px] leading-none text-white ring-2 ring-[#16284a] ${className}`}
            style={{ fontFamily: MONO, fontWeight: 700 }}>
            {count > 99 ? "99+" : count}
        </span>
    )
}
